import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ScrollViewModule } from '../scroll-view/scroll-view.module';
import { TabsComponent } from './tabs.component';

@NgModule({
  imports: [CommonModule, ScrollViewModule],
  declarations: [TabsComponent],
  exports: [TabsComponent],
})
export class TabsModule {}
